import { HTTP, ENDPOINT } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";



export const fetchGoogleUserData = async (accessToken) => {
  try {
    const res = await fetch("https://www.googleapis.com/oauth2/v2/userinfo", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!res.ok) throw new Error(`Error fetching user data: ${res.statusText}`);


    const userData = await res.json();

    // Filtra solo los datos que necesitas
    const filteredUserData = {
      email: userData.email,
      name: userData.name,
      family_name: userData.family_name,
      given_name: userData.given_name,
      id: userData.id,
      picture: userData.picture,
    };

    return filteredUserData;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};

// registro con gmail 
export const enrollUserWithGoogle = async (accessToken, userType) => {
  try {
    // Obtener los datos filtrados del usuario
    const userData = await fetchGoogleUserData(accessToken);

    // Enviar los datos al servidor
    const res = await fetchFromLawfeed({
      method: HTTP.POST,
      endpoint: ENDPOINT.google_register ,
      queryParams: [{ type: userType }],
      body: { UserData: userData },
    });
    
  

    const responseData =  res;
    console.log("Respuesta del servidor:", responseData);


    if (responseData.error){
      console.error("Error en el registro:", responseData.error);
      return responseData.error;
    }
    return responseData;
  } catch (error) {
    console.error("Error enrolling user:", error);
    throw error;
  }
};



export const loginUserWithGoogle = async (accessToken) => {
  try {
    // Obtener los datos filtrados del usuario
    const userData = await fetchGoogleUserData(accessToken);

    // Enviar los datos al servidor
    const res = await fetchFromLawfeed({
      endpoint: ENDPOINT.LOGIN,
      method: HTTP.POST,
      body: { UserData: userData },
    });


    const responseData =  res;

    // Imprimir respuesta detallada en consola
    console.log("Respuesta del servidor:", responseData);
    if (responseData.error){
      console.error("Error en el registro:", responseData.error);
      return responseData.error;
    }
    return responseData;
  } catch (error) {
    console.error("Error enrolling user:", error);
    throw error;
  }
};